import React, { useEffect, useState } from 'react';
import { Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material';
import axios from 'axios';
import { toast } from 'react-toastify';
import CustomBackdrop from '../../../../../components/backdrop';
import getEnvironement from '../../../../../environnement';
import CustomSelect from '../../../../../components/customSelect';

export default function StatutDialog({
  open,
  handleClose,
  reloadData,
  soumission,
}) {
  const [statut, setStatut] = useState(soumission?.isPayement);
  const [statutError, setStatutError] = useState('');
  const [openBackdrop, setOpenBackdrop] = useState(false);

  const editStatut = async () => {
    const url = `${getEnvironement().API_URL}/editPayementSoumission/${soumission.id}`;
    const data ={
      statut
    };
    const config = {
      headers: {
        'Content-Type': 'application/json',
      },
    }

    handleClose();
    setOpenBackdrop(true);

    await axios.put(url, data, config)
      .then(() => setTimeout(() => setOpenBackdrop(false), 1000))
      .then(() => reloadData())
      .then(() => toast.success(`La soumission ${soumission.id} a bien été modifiée`))
      .catch((err) => console.log(err));
  };

  useEffect(() => {
    if (open) {
      setStatut(soumission?.isPayement);
    }
  }, [soumission?.isPayement, open]);

  return (
    <>
      <CustomBackdrop open={openBackdrop} setOpen={setOpenBackdrop} />
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        sx={{paddingBottom: '0px'}}
      >
        <DialogTitle id="alert-dialog-title">
          <p className='text-2xl sm:text-3xl font-medium font-inter mt-5'>Soumission numéro : {soumission?.id}</p>
          
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            <CustomSelect
              items={[
                {id: 1, label: 'Non payé', value: 0},
                {id: 2, label: 'Payé', value: 1},
              ]}
              placeholder='Statut'
              value={statut}
              setValue={setStatut}
              isError={statutError !== ''}
              error={statutError}
            />
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <div className='flex justify-between px-5 w-full gap-5'>
            <div
              className='group rounded-[20px] py-2 sm:py-3 mb-5 cursor-pointer bg-primary hover:bg-primaryDark w-full'
              onClick={handleClose}
            >
              <p className='font-medium text-2xl sm:text-3xl w-full text-center text-white'>Annuler</p>
            </div>
            <div
              className='group rounded-[20px] py-2 sm:py-3 mb-5 cursor-pointer bg-primary hover:bg-primaryDark w-full'
              onClick={editStatut}
            >
              <p className='font-medium text-2xl sm:text-3xl w-full text-center text-white'>Confirmer</p>
            </div>
          </div>
        </DialogActions>
      </Dialog>
    </>
  );
}
